import { createContext } from 'react';

const AttendeeBroadcastContext = createContext();

export default AttendeeBroadcastContext;
